module.exports = __webpack_public_path__ + "img/project-2.89c70ce1.jpg";